export abstract class Strategy {
    public pathToGo: string;
    abstract hasCondition(request): boolean;
    abstract setStrategy(request?): void;
}